import { signOut } from "firebase/auth";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Card, Container, Navbar, Offcanvas } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { CgSearch } from "react-icons/cg";
import { MdOutlineShoppingBag } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import theKoreanMallLogo from "../../../assets/images/thekoreanmall-logo-invert.png";
import auth from "../../../init.firebase";
import "./ResponsiveNavbar.scss";
import SearchModal from "./SearchModal";
import OffCanvasTop from "./OffCanvasTop";
import { TiSocialFacebook } from "react-icons/ti";
import { ImYoutube } from "react-icons/im";
import { FaInstagram } from "react-icons/fa";
import { CgMathEqual } from "react-icons/cg";
import { Spin as Hamburger } from "hamburger-react";
import { useGetAddToCartDataByEmailQuery } from "../../../redux/addToCart/addToCartApi";
import { useGetAllCategoryQuery } from "../../../redux/categories/categoriesApi";

const ResponsiveNavbar = ({ setShow: setShowModal }) => {
  // const { category } = useSelector((state) => state.category);
  const [user] = useAuthState(auth);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [haveUser, setHaveUser] = useState(true);

  const {
    data: addToCartData,
    isLoading,
    isError,
  } = useGetAddToCartDataByEmailQuery(user?.email, { skip: haveUser });
  const {
    data: category,
    isLoading: categoriesLoading,
    isError: categoriesError,
  } = useGetAllCategoryQuery();

  useEffect(() => {
    if (user?.email) {
      setHaveUser(false);
    }
  }, [user?.email]);

  //handle log out
  const handleSignOut = () => {
    localStorage.clear();
    signOut(auth);
  };

  const totalQuantity = addToCartData?.products?.reduce(
    (tQuantity, currentQuantity) => tQuantity + currentQuantity?.quantity,
    0
  );

  return (
    <>
      <div
        className="first-heading text-center bg-danger text-white d-flex align-items-center justify-content-center"
        style={{
          position: "sticky",
          top: "0",
          zIndex: "1020",
          height: "30px",
        }}
      >
        <div className="my-auto">WELCOME TO THE KOREAN MALL</div>
      </div>
      <Navbar
        bg="dark"
        style={{ backgroundColor: "#2b2d42" }}
        expand="lg"
        sticky="top"
      >
        <Container>
          <div className="d-flex align-items-center justify-content-between w-100 ">
            <div className="text-white" style={{ marginLeft: "-14px" }}>
              <Hamburger size={25} toggled={showNav} toggle={setShowNav} />
            </div>

            <Navbar.Brand as={Link} to="/" style={{ marginLeft: "30px" }}>
              <img width={170} src={theKoreanMallLogo} alt="" />
            </Navbar.Brand>

            <div className="d-flex align-items-center text-white">
              <CgSearch
                onClick={() => setShowSearchModal(true)}
                style={{
                  width: "25px",
                  height: "22px",
                  marginTop: "4px",
                  marginRight: "10px",
                }}
              />
              <div
                onClick={() => setShowModal(true)}
                className="add_to_cart_icon"
              >
                <MdOutlineShoppingBag
                  style={{ width: "25px", height: "22px", marginRight: "6px" }}
                />
                <div className="add_to_cart_number">
                  <span>{totalQuantity ? totalQuantity : 0}</span>
                </div>
              </div>
            </div>
          </div>
          <Container>
            <Offcanvas
              show={showNav}
              placement="top"
              className="off_canvas_background"
            >
              <Offcanvas.Header
                style={{
                  paddingTop: "0",
                  paddingBottom: "0",
                  paddingLeft: "5%",
                  marginTop: "5%",
                  fontSize: "16px",
                  letterSpacing: "0.125rem",
                  textTransform: "uppercase",
                  fontWeight: "700",
                  position: "relative",
                }}
              >
                Menu
                <div className="second-heading">
                  <a
                    target={"_blank"}
                    className="logo_parent"
                    rel="noreferrer"
                    href="https://www.facebook.com/thekoreanmallbd/"
                  >
                    <TiSocialFacebook className="social-icon" />
                  </a>
                  <a
                    target={"_blank"}
                    className="logo_parent"
                    rel="noreferrer"
                    href="https://www.youtube.com/channel/UC-LVy_dKbP657BCCOsPpYCQ"
                  >
                    <ImYoutube className="social-icon" />
                  </a>
                  <a
                    target={"_blank"}
                    className="logo_parent"
                    rel="noreferrer"
                    href="https://www.instagram.com/thekoreanmallbd/"
                  >
                    <FaInstagram className="social-icon" />
                  </a>
                </div>
              </Offcanvas.Header>
              <Offcanvas.Body
                style={{
                  padding: "0",
                }}
                className="d-flex flex-column"
              >
                <div>
                  {category?.result?.length > 0
                    ? category?.result?.map((grandParent) => (
                        <OffCanvasTop
                          key={grandParent._id}
                          name={grandParent.title}
                          parent={grandParent.children}
                          showNav={showNav}
                          setShowNav={setShowNav}
                        />
                      ))
                    : null}
                </div>
                <div className="off_canvas_button mt-3">
                  {/* <div
                    onClick={() => setShowNav(false)}
                    className="d-flex align-items-center justify-content-center w-100"
                  >
                    <AiOutlineArrowUp
                      style={{ fontSize: "2rem" }}
                      className="tap_top_button"
                    />
                  </div> */}
                  <div
                    className="d-flex justify-content-center align-items-center   px-2 gap-2 "
                    style={{
                      // backgroundColor: "#E6EAEB",
                      minWidth: "100%",
                    }}
                  >
                    {!user ? (
                      <Button
                        className="shadow-none py-3 responsive_login_button shadow-none"
                        as={Link}
                        variant="light"
                        to="/account/login"
                        onClick={() => setShowNav(false)}
                      >
                        LOGIN
                      </Button>
                    ) : (
                      <Button
                        className="shadow-none py-3 responsive_login_button"
                        variant="light"
                        onClick={handleSignOut}
                      >
                        LOGOUT
                      </Button>
                    )}
                    <div
                      style={{
                        width: "0.0938rem",
                        height: "100%",
                        backgroundColor: "black",
                      }}
                    />
                    <Button
                      className="shadow-none py-3 responsive_login_button"
                      onClick={() => setShowNav(false)}
                      variant="light"
                      as={Link}
                      to="/account/register"
                    >
                      SIGN UP
                    </Button>
                  </div>
                  <div
                    onClick={() => setShowNav(false)}
                    className="d-flex align-items-center justify-content-center w-100"
                  >
                    <CgMathEqual
                      style={{ fontSize: "2rem" }}
                      className="tap_top_button"
                    />
                  </div>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </Container>
        </Container>

        <SearchModal
          showSearchModal={showSearchModal}
          setShowSearchModal={setShowSearchModal}
        />
      </Navbar>
    </>
  );
};

export default ResponsiveNavbar;
